import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import { GoogleMapUrl, buildThumbnailUrl } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
import withData from '@bd/bdcore-data';
import { colors, typography } from '../styles';

const styles = css`
  width: 100%;
  margin: 0 0 15px 0;
  @media (min-width: 992px) {
    margin: 0 0 30px 0;
  }
  .HomeCard_wrapper {
    display: flex;
    box-shadow: 1px 4px 6px rgba(0,0,0,.2);
  }
  .HomeCard_inner {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #FFFFFF;
    a {
      color: ${colors.color1};
      text-decoration: none;
    }
    a.HomeCard_mediaGoogleMap {
      font-weight:700;
      color: ${colors.color1};
      text-decoration: none;
    }
  }
  .HomeCard_address {
    background: ${colors.color3};
    padding:20px;
    margin:0;
    font:700 20px/1 ${typography.SansSerif};
    .HomeCard_addressArea {
      font:300 16px/1 ${typography.SansSerif};
    }
  }
  .HomeCard_media {
    img {
      width: 100%;
    }
  }
  .HomeCard_content {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    background-color: ${colors.color3Lightest};
    position: relative;
    color:black;

    .HomeCard_priceWrapper {
      padding: 20px;
      border-top:1px solid ${colors.color3};
      font:700 24px/1 ${typography.SansSerif};
      margin: 0;
      text-decoration: none;
      color:${colors.color1};
      display: flex;
      flex-flow:row nowwrap;
      justify-content: space-between;
      align-items: center;
    }
    .CommunityCard_Content-arrow {
      transform:rotate(-90deg);
      width:10px;
      height:8px;
    }
    }
    .HomeCard_iconList {
      display: flex;
      flex-flow:row wrap;
      justify-content: center;
      list-style-type: none;
      padding:10px;
      margin:0;
    }
    .HomeCard_iconListItem {
      font-size: 15px;
      line-height: 1;
      text-align: left;
      width:50%;
      padding: 10px;
    }
    .HomeCard_iconListIcon {
      margin: 0 5px 0 0;
      @media (min-width: 480px) {
        margin: 0 8px 0 0;
      }
      img {
        height: 15px;
        width: auto;
        @media (min-width: 480px) {
          width:auto;
          height:auto;
        }
      }
    }
  }
`;


function HomeCard({ home }) {
  return (
    <div className={styles}>
      <div className="HomeCard_wrapper">
        <div className="HomeCard_inner">
          <Link name="home-detail" home={home}>
            <h4 className="HomeCard_address">
              {get(home, 'address.streetAddress')}<br />
              <span className="HomeCard_addressArea">
                {`${get(home, 'address.addressLocality')}, ${get(home, 'address.addressRegion')} ${get(home, 'address.postalCode')}`}
              </span>
            </h4>
          </Link>
          <div className="HomeCard_media">
            <Link name="home-detail" home={home}>
              <img src={buildThumbnailUrl(get(home, 'photos[0].contentUrl'), { width: 710, height: 400, exact: true })} alt="Home Exterior" />
            </Link>
          </div>
          <div className="HomeCard_content">
            <ul className="HomeCard_iconList">
              {
                get(home, 'beds') &&
                <li className="HomeCard_iconListItem">
                  <span className="HomeCard_iconListIcon"><img src="/images/icon-beds.svg" alt="" width="24" height="21" /></span>
                  <span className="HomeCard_iconListValue">{get(home, 'beds')} </span>
                  <span>Beds</span>
                </li>
              }
              {
                get(home, 'bathsFull') &&
                <li className="HomeCard_iconListItem">
                  <span className="HomeCard_iconListIcon"><img src="/images/icon-baths.svg" alt="" /></span>
                  <span className="HomeCard_iconListValue">{get(home, 'bathsFull')}{get(home, 'bathsHalf', 0) > 0 && '.5'} </span>
                  <span>Baths</span>
                </li>
              }
              {
                get(home, 'sqft') &&
                <li className="HomeCard_iconListItem">
                  <span className="HomeCard_iconListIcon"><img src="/images/icon-sqft.svg" alt="" /></span>
                  <span className="HomeCard_iconListValue">{numeral(get(home, 'sqft')).format('0,0')} </span>
                  <span>SQ FT</span>
                </li>
              }
              <li className="HomeCard_iconListItem">
                <span className="HomeCard_iconListIcon"><img src="/images/icon-map-pin-ko.svg" alt="" /></span>
                <a href={GoogleMapUrl(home)} className="HomeCard_mediaGoogleMap" target="_blank" rel="noopener noreferrer">{get(home, 'address.addressLocality')}</a>
              </li>
            </ul>
            {
              get(home, 'price') &&
              <Link name="home-detail" home={home}>
                <div className="HomeCard_priceWrapper">
                  {numeral(get(home, 'price')).format('$0,0')}<img src="/images/icon-triangle.svg" className="CommunityCard_Content-arrow" alt="arrow icon" />
                </div>
              </Link>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

HomeCard.propTypes = {
  home: PropTypes.object.isRequired,
  // widget: PropTypes.object.isRequired,
};

HomeCard.defaultProps = {
  plan: undefined,
  community: undefined,
};

export default withData(
  {
    home: true,
    plan: true,
    community: true,
    // widget: 'default_image',
  },
  {
    required: {
      home: true,
    },
  },
)(HomeCard);



// WEBPACK FOOTER //
// ./src/components/HomeCard.js